module.exports = __webpack_public_path__ + "static/img/我的-B@3x.dd4b920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/bottom/我的-B@3x.png
// module id = 1256
// module chunks = 382